// import React, { useState } from "react";
// import { styled, useTheme } from "@mui/material/styles";
// import { NavLink, withRouter } from "react-router-dom";
// import MuiDrawer from "@mui/material/Drawer";
// import Box from "@mui/material/Box";
// import CssBaseline from "@mui/material/CssBaseline";
// import List from "@mui/material/List";
// import Divider from "@mui/material/Divider";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
// import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
// import CarIcon from "@mui/icons-material/DirectionsCar";
// import TripsIcon from "@mui/icons-material/Explore";
// import ExcludeZoneIcon from "@mui/icons-material/Block";
// import CityConfigIcon from "@mui/icons-material/LocationCity";
// import ServicesIcon from "@mui/icons-material/Build";
// import EarningsIcon from "@mui/icons-material/AttachMoney";
// import { Trans } from "react-i18next";
// import IconButton from "@mui/material/IconButton";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import CruzeLog from '../../assets/images/logo/Cruze_White.png';
// import CruzeRound from '../../assets/images/logo/round.png';
// import { Link } from "react-router-dom";
// import NotificationsIcon from '@mui/icons-material/Notifications';

// const drawerWidth = 240;

// const openedMixin = (theme) => ({
//   width: drawerWidth,
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: "hidden",
//   backgroundColor: "#121621", // Set background color
//   color: "#b3b9c6", // Set text color
// });

// const closedMixin = (theme) => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: "hidden",
//   backgroundColor: "#121621", // Set background color
//   color: "#b3b9c6", // Set text color
//   width: `calc(${theme.spacing(7)} + 1px)`,
//   [theme.breakpoints.up("sm")]: {
//     width: `calc(${theme.spacing(8)} + 1px)`,
//   },
// });

// const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== "open" })(
//   ({ theme, open }) => ({
//     width: drawerWidth,
//     flexShrink: 0,
//     whiteSpace: "nowrap",
//     boxSizing: "border-box",
//     ...(open && {
//       ...openedMixin(theme),
//       "& .MuiDrawer-paper": openedMixin(theme),
//     }),
//     ...(!open && {
//       ...closedMixin(theme),
//       "& .MuiDrawer-paper": closedMixin(theme),
//     }),
//   })
// );

// function Sidebar1({ children }) {
//   const theme = useTheme();

//   const menuItems = [
//     { text: "Dashboard", icon: <GridViewRoundedIcon />, to: "/dashboard" },
//     { text: "Users", icon: <PeopleAltRoundedIcon />, to: "/users" },
//     { text: "Riders", icon: <CarIcon />, to: "/riders" },
//     { text: "Trips", icon: <TripsIcon />, to: "/trips" },
//     { text: "Exclude Zones", icon: <ExcludeZoneIcon />, to: "/exclude-zone" },
//     { text: "City Config", icon: <CityConfigIcon />, to: "/cityconfig" },
//     { text: "Services", icon: <ServicesIcon />, to: "/dashboard/services" },
//     { text: "Earnings", icon: <NotificationsIcon />, to: "/notification" },
//   ];
//   const [open, setOpen] = useState(false);

//   const handleDrawerOpen = () => {
//     setOpen(true);
//   };

//   const handleDrawerClose = () => {
//     setOpen(false);
//   };

//   const handleDrawerToggle = () => {
//     if (open) {
//       handleDrawerClose();
//     } else {
//       handleDrawerOpen();
//     }
//   };

//   return (
//     <Box sx={{ display: "flex" }}>
//       <CssBaseline />
//       <Drawer variant="permanent" open={open}>
//         <Box sx={{ display: "flex", alignItems: "center", justifyContent: open ? "space-between" : "center", p: 1 }}>
//           <Link className="navbar-brand brand-logo" to="/">
//           {open ?(
//             <img src={CruzeLog} alt="logo" style={{ width:'120px' , height: 'auto' }} />
//           ):(
//             <img src={CruzeRound} alt="logo" style={{ width: '50px', height: 'auto', }} />
//           )}

//           </Link>
//           <IconButton onClick={handleDrawerToggle} sx={{ color:"#b3b9c6", ml: open ? 1 : 0 }} >
//             {open ? (
//               theme.direction === "rtl" ? <ChevronRightIcon /> : <ChevronLeftIcon />
//             ) : (
//               theme.direction === "rtl" ? <ChevronLeftIcon /> : <ChevronRightIcon />
//             )}
//           </IconButton>
//         </Box>
//         <Divider />
//         <List>
//           {menuItems.map((item) => (
//             <ListItem key={item.text} disablePadding sx={{ display: "block",}}>
//               <ListItemButton
//                 component={NavLink}
//                 to={item.to}
//                 sx={{
//                   minHeight: 30,
//                   justifyContent: open ? "initial" : "center",
//                   px: 2.5,
//                   color: "inherit",
//                   "&:hover": {
//                     backgroundColor: "rgba(255, 255, 255, 0.04)", // White color with 0.04 opacity
//                   },
//                   "&.active": {
//                     color: "white", // Set active color as white
//                   },
//                 }}
//                 activeClassName="active"
//               >
//                 <ListItemIcon
//                   sx={{
//                     minWidth: 0,
//                     mr: open ? 3 : "auto",
//                     justifyContent: "center",
//                     color: "inherit",
//                     fontSize: "small"
//                   }}
//                 >
//                   {item.icon}
//                 </ListItemIcon>
//                 <ListItemText primary={<Trans>{item.text}</Trans>} sx={{
//                     opacity: open ? 1 : 0,
//                     '& .MuiTypography-root': {
//                       fontSize: '0.875rem' // Set text font size to smaller
//                     }
//                   }} />
//               </ListItemButton>
//             </ListItem>
//           ))}
//         </List>
//       </Drawer>
//     </Box>
//   );
// }

// export default Sidebar1;

import React, { useState, useEffect } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { NavLink, withRouter } from "react-router-dom";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import CarIcon from "@mui/icons-material/DirectionsCar";
import TripsIcon from "@mui/icons-material/Explore";
import HdrAutoIcon from '@mui/icons-material/HdrAuto';
import ExcludeZoneIcon from "@mui/icons-material/Block";
import CityConfigIcon from "@mui/icons-material/LocationCity";
import ServicesIcon from "@mui/icons-material/Build";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import CruzeLog from "../../assets/images/logo/Cruze_White.png";
import CruzeRound from "../../assets/images/logo/round.png";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { Trans } from "react-i18next";
import TicketIcon from "../../assets/images/dashboard/ticket (1).png";
import PlaceIcon from "@mui/icons-material/Place";
import { Payment } from "@mui/icons-material";
import FeaturedVideoIcon from '@mui/icons-material/FeaturedVideo';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { useLocation, useParams, useNavigate } from "react-router-dom";
import Collapse from '@mui/material/Collapse';




// Add these imports at the top with your other icon imports
// import LocalMoviesIcon from '@mui/icons-material/LocalMovies';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import TheatersIcon from '@mui/icons-material/Theaters';
import ScheduleIcon from '@mui/icons-material/Schedule';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ApprovalIcon from '@mui/icons-material/Approval';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import InsightsIcon from '@mui/icons-material/Insights';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import BarChartIcon from '@mui/icons-material/BarChart';
// import FileTextIcon from '@mui/icons-material/FileText';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import SummarizeIcon from '@mui/icons-material/Summarize';
import AddLocationIcon from '@mui/icons-material/AddLocation';



const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  backgroundColor: "#121621",
  color: "#b3b9c6",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  backgroundColor: "#121621",
  color: "#b3b9c6",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

// const Drawer = styled(MuiDrawer, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   width: drawerWidth,
//   flexShrink: 0,
//   whiteSpace: "nowrap",
//   boxSizing: "border-box",
//   ...(open && {
//     ...openedMixin(theme),
//     "& .MuiDrawer-paper": openedMixin(theme),
//   }),
//   ...(!open && {
//     ...closedMixin(theme),
//     "& .MuiDrawer-paper": closedMixin(theme),
//   }),
// }));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": {
      ...openedMixin(theme),
      display: "flex",
      flexDirection: "column",
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": {
      ...closedMixin(theme),
      display: "flex",
      flexDirection: "column",
    },
  }),
}));

function Sidebar1({ children }) {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [cruzeOpen, setCruzeOpen] = useState(false);
  const [ticketsOpen, setTicketsOpen] = useState(false);
  const [tourPackageOpen, setTourPackageOpen] = useState(false);
  const [analyticsOpen, setAnalyticsOpen] = useState(false);

  // const showTickets = dashboardType === "ticket-dashboard";
  const { firstname, lastname, role = "" } = JSON.parse(localStorage.getItem("admin"));


  console.log('role in sidebar', role);

  const isTicketAdmin = role === "ticket-admin";


  const isEarningsOnly = role === "earnings-report-only";

  const navigate = useNavigate();


  const location = useLocation();


  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleDrawerToggle = () => {
    if (open) {
      handleDrawerClose();
    } else {
      handleDrawerOpen();
    }
  };

  const handleCruzeClick = () => {
    setCruzeOpen(!cruzeOpen);
  };

  const handleTicketsClick = () => {
    // navigate("/tickets-dashboard"); // ✅ navigates to TicketDashboard
    navigate("/moviebooking");
    // setTicketsOpen(!ticketsOpen);

    if (ticketsOpen) {
      // If closing the Tickets menu, reset all nested menus
      setOpenMenus({});
    }
    setTicketsOpen(!ticketsOpen);


  };
  const handleTourPackageClick = () => {
    setTourPackageOpen(!tourPackageOpen);
  };

  const handleAnalyticsClick = () => {
    setAnalyticsOpen(!analyticsOpen);
  };


  const [openMenus, setOpenMenus] = useState({});

  const handleToggle = (menuName) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menuName]: !prev[menuName],
    }));
  }


    // Add role-based redirect effect
    useEffect(() => {
      if (role === "earnings-report-only" && location.pathname === "/dashboard") {
        navigate("/totalReport", { replace: true });
      }
    }, [ role, location, navigate]);

  // const cruzeItems = [
  //   { text: "Dashboard", icon: <GridViewRoundedIcon />, to: "/dashboard" },
  //   { text: "Cab Request", icon: <CarIcon />, to: '/cabrequests' },
  //   { text: "Auto Bid Matrix", icon: <HdrAutoIcon />, to: '/autoBidMatrix' },
  //   { text: "Advertise", icon: <FeaturedVideoIcon />, to: "/advertise" },
  //   { text: "Offers", icon: <LocalOfferIcon />, to: "/offers" },
  //   { text: "Users", icon: <PeopleAltRoundedIcon />, to: "/users" },
  //   { text: "Riders", icon: <CarIcon />, to: "/riders" },
  //   { text: "Trips", icon: <TripsIcon />, to: "/trips" },
  //   // { text: "Payments", icon: <Payment />, to: "/payment" },
  //   // { text: "Payments", icon: <Payment />, to: "/paymentSelector" },
  //   { text: "Processing", icon: <DriveFolderUploadIcon />, to: "/fileUpload" },
  //   { text: "Settelment", icon: <SummarizeIcon />, to: "/settlementReport" },
  //   { text: "Exclude Zones", icon: <ExcludeZoneIcon />, to: "/exclude-zone" },
  //   { text: "City Config", icon: <CityConfigIcon />, to: "/cityconfig" },
  //   { text: "Services", icon: <ServicesIcon />, to: "/dashboard/services" },
  //   { text: "Notification", icon: <NotificationsIcon />, to: "/notification" },
  //   { text: "Locale", icon: <PlaceIcon />, to: "/nearyByLocation" },
  //   { text: "CruzeTypes", icon: <CarIcon />, to: "/cruzeTypes" },
  // ];





  const cruzeItems = [
    { text: "Dashboard", icon: <GridViewRoundedIcon />, to: "/dashboard" },
    { text: "Cab Request", icon: <CarIcon />, to: '/cabrequests' },
    { text: "Auto Bid Matrix", icon: <HdrAutoIcon />, to: '/autoBidMatrix' },
    {text:"Zones",icon:<AddLocationIcon/>,to:"/zones"},
    { text: "Advertise", icon: <FeaturedVideoIcon />, to: "/advertise" },
    { text: "Offers", icon: <LocalOfferIcon />, to: "/offers" },
    { text: "Users", icon: <PeopleAltRoundedIcon />, to: "/users" },
    { text: "Riders", icon: <CarIcon />, to: "/riders" },
    { text: "Trips", icon: <TripsIcon />, to: "/trips" },
    { 
      text: "Payments", 
      icon: <Payment />, 
      children: [
        { text: "Processing", icon: <DriveFolderUploadIcon />, to: "/fileUpload" },
        { text: "Settlement", icon: <SummarizeIcon />, to: "/settlementReport" }
      ]
    },
    { text: "Exclude Zones", icon: <ExcludeZoneIcon />, to: "/exclude-zone" },
    { text: "City Config", icon: <CityConfigIcon />, to: "/cityconfig" },
    { text: "Services", icon: <ServicesIcon />, to: "/dashboard/services" },
    { text: "Notification", icon: <NotificationsIcon />, to: "/notification" },
    { text: "Locale", icon: <PlaceIcon />, to: "/nearyByLocation" },
    { text: "CruzeTypes", icon: <CarIcon />, to: "/cruzeTypes" },
  ];



  const TourPackageItems = [
    { text: "Places", to: "/tourPackagePlaces" },
    { text: "Packages", to: "/packages" },
    { text: "Spots", to: "/spots" },
    { text: "Coupons", to: '/coupons' }
    // { text: "Places", to: "/tourPackagePlaces" },
  ];


  // For eranings


  const earningsOnlyItems = [
    {
      text: "Insights",
      icon: <InsightsIcon />,
      to: "/tickets-dashboard"
    },
    {
      text: 'Show Performance',
      icon: <TrendingUpIcon />,
      to: '/showPerformance'
    },
    {
      text: 'Revenue Analytics',
      icon: <MonetizationOnIcon />,
      to: '/reports'
    },
    {
      text: "Earnings per Booking",
      icon: <BarChartIcon />,
      to: '/totalReport'
    },
    {
      text: 'Earning per Ticket',
      icon: <AccountBalanceWalletIcon />,
      to: '/gstSplit'
    },
  ];





  // const ticketsItems = [
  //   { text: "Book Movie", to: "/moviebooking" },
  //   { text: "Movie Management", to: "/movies" },

  //   { text: "Manage Showtimes", to: "/showSchedules" },
  //   { text: "Dynamic Pricing", to: "/dynamicPricing" },
  //   { text: "Dynamic Report", to: "/dynamicReport" },
  //   { text: "Purchase Cost", to: "/purchaseCost" },
  //   { text: "Approvals", to: "/approvals" },
  //   {
  //     text: "Analytics",
  //     children: [
  //       { text: "Insights", to: "/tickets-dashboard" },
  //       { text: 'Show Performance', to: '/showPerformance' },
  //       { text: 'Revenue Analytics', to: '/reports' },
  //       { text: 'Earnings Report', to: '/totalReport' },


  //       // { text: "Monthly Report", to: "/reports/monthly" },
  //       // { text: "User Behavior", to: "/reports/users" },
  //     ],
  //   },
  // ];







  // Update your ticketsItems array with icons
  const ticketsItems = [
    {
      text: "Book Movie",
      icon: <BookOnlineIcon />,
      to: "/moviebooking"
    },
    {
      text: "Movie Management",
      icon: <TheatersIcon />,
      to: "/movies"
    },
    {
      text: "Manage Showtimes",
      icon: <ScheduleIcon />,
      to: "/showSchedules"
    },
    {
      text: "Dynamic Pricing",
      icon: <PriceChangeIcon />,
      to: "/dynamicPricing"
    },
    {
      text: "Dynamic Report",
      icon: <AssessmentIcon />,
      to: "/dynamicReport"
    },
    {
      text: "Purchase Cost",
      icon: <ReceiptIcon />,
      to: "/purchaseCost"
    },
    {
      text: "Approvals",
      icon: <ApprovalIcon />,
      to: "/approvals"
    },
    {
      text: "Analytics",
      icon: <AnalyticsIcon />,
      children: [
        {
          text: "Insights",
          icon: <InsightsIcon />,
          to: "/tickets-dashboard"
        },
         {
          text: "TotalReport",
          icon: <InsightsIcon />,
          to: "/fullReport"
        },
        {
          text: 'Show Performance',
          icon: <TrendingUpIcon />,
          to: '/showPerformance'
        },
        {
          text: 'Revenue Analytics',
          icon: <MonetizationOnIcon />,
          to: '/reports'
        },
        {
          text: 'Earnings per Booking',
          icon: <BarChartIcon />,
          to: '/totalReport'
        },
        {
          text: 'Earning per Ticket',
          icon: <AccountBalanceWalletIcon />,
          to: '/gstSplit'
        },
      ],
    },
  ];



  return (
    <Box sx={{ display: "flex", zIndex: '100' }}>
      <CssBaseline />
      <Drawer variant="permanent" open={open}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            // justifyContent: open ? "space-between" : "center",
            justifyContent: open ? "space-between" : "flex-end", // Changed to flex-end
            p: 1,
            flexShrink: 0, // Prevent header from shrinking
            minHeight: '64px' // Ensure consistent height
          }}
        >
          {/* <Link className="navbar-brand brand-logo" to="/">
            {open ? (
              <img
                src={CruzeLog}
                alt="logo"
                style={{ width: "120px", height: "auto" }}
              />
            ) : (
              <img
                src={CruzeRound}
                alt="logo"
                style={{ width: "50px", height: "auto" }}
              />
            )}
          </Link> */}


          {!isTicketAdmin ? (
            <Link className="navbar-brand brand-logo" to="/">
              {open && (
                <img
                  src={CruzeLog}
                  alt="logo"
                  style={{ width: "120px", height: "auto" }}
                />
              )
                //  :
                //  (
                //   <img
                //     src={CruzeRound}
                //     alt="logo"
                //     style={{  width: "60px", height: "auto" }}
                //   />
                // )

              }
            </Link>
          ) : (
            <>
              {open && (
                <img
                  src={CruzeLog}
                  alt="logo"
                  style={{ width: "120px", height: "auto" }}
                />
              )

                // : (
                //   <img
                //     src={CruzeRound}
                //     alt="logo"
                //     style={{ width: "50px", height: "auto" }}
                //   />
                // )

              }
            </>
          )}






          <IconButton
            onClick={handleDrawerToggle}
            sx={{ color: "#b3b9c6", ml: open ? 1 : 0 }}
          >
            {open ? (
              theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )
            ) : theme.direction === "rtl" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </Box>
        <Divider />


        <Box
          sx={{
            flexGrow: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            '&::-webkit-scrollbar': {
              width: '6px',
            },
            '&::-webkit-scrollbar-track': {
              background: '#121621',
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#b3b9c6',
              borderRadius: '3px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: '#ffffff',
            }
          }}
        >


          <List sx={{ p: 0 }}>
            {isEarningsOnly ? (


              earningsOnlyItems.map((item) => (
                <React.Fragment key={item.text}>
                  <ListItemButton
                    component={NavLink}
                    to={item.to}
                    sx={{
                      minHeight: 40,
                      px: 2,
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.04)",
                      },
                      "&.active": {
                        color: "white",
                      },
                    }}
                  >
                    <ListItemIcon sx={{
                      minWidth: 0,
                      mr: open ? 2.5 : "auto",
                      color: "inherit",
                    }}>
                      {item.icon}
                    </ListItemIcon>
                    {open && (
                      <ListItemText
                        primary={item.text}
                        primaryTypographyProps={{
                          fontSize: '0.875rem',
                        }}
                      />
                    )}
                  </ListItemButton>
                  <Divider />
                </React.Fragment>
              ))
              // Show only Earnings Report for earnings-report-only role
              // <>
              //   <ListItemButton onClick={() => navigate('/totalReport')}>
              //     <ListItemIcon>
              //       <BarChartIcon />
              //     </ListItemIcon>
              //     <ListItemText primary="Earnings Report" />
              //   </ListItemButton>
              //   <Divider />
              // </>
            ) : (
              // Show full sidebar for other roles
              <>
                {!isTicketAdmin && (
                  <>
                    <ListItemButton onClick={handleCruzeClick}>
                      <ListItemIcon>
                        <img
                          src={CruzeRound}
                          alt="Cruze"
                          style={{ width: "24px", height: "24px" }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Cruze" />
                      {cruzeOpen ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Divider />
                    {/* {cruzeOpen && (
                      <List component="div" disablePadding>
                        {cruzeItems.map((item) => (
                          <ListItem key={item.text} disablePadding sx={{ display: "block" }}>
                            <ListItemButton
                              component={NavLink}
                              to={item.to}
                              sx={{
                                minHeight: 30,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                                color: "inherit",
                                "&:hover": {
                                  backgroundColor: "rgba(255, 255, 255, 0.04)",
                                },
                                "&.active": {
                                  color: "white",
                                },
                              }}
                              activeClassName="active"
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: open ? 3 : "auto",
                                  justifyContent: "center",
                                  color: "inherit",
                                  fontSize: "small",
                                }}
                              >
                                {item.icon}
                              </ListItemIcon>
                              <ListItemText
                                primary={<Trans>{item.text}</Trans>}
                                sx={{
                                  opacity: open ? 1 : 0,
                                  "& .MuiTypography-root": {
                                    fontSize: "0.875rem",
                                  },
                                }}
                              />
                            </ListItemButton>
                          </ListItem>
                        ))}
                      </List>
                    )} */}









{cruzeOpen && (
  <List component="div" disablePadding>
    {cruzeItems.map((item) => (
      <React.Fragment key={item.text}>
        <ListItem disablePadding sx={{ display: "block" }}>
          {item.children ? (
            <>
              <ListItemButton
                onClick={() => handleToggle(item.text)}
                sx={{
                  minHeight: 40,
                  px: 2,
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.04)",
                  },
                }}
              >
                <ListItemIcon sx={{
                  minWidth: 0,
                  mr: open ? 2.5 : "auto",
                  color: "inherit",
                }}>
                  {item.icon}
                </ListItemIcon>
                {open && (
                  <>
                    <ListItemText
                      primary={<Trans>{item.text}</Trans>}
                      primaryTypographyProps={{
                        fontSize: '0.875rem',
                      }}
                    />
                    {openMenus[item.text] ? <ExpandLess /> : <ExpandMore />}
                  </>
                )}
              </ListItemButton>

              <Collapse in={openMenus[item.text]} unmountOnExit>
                <List component="div" disablePadding>
                  {item.children.map((subItem) => (
                    <ListItem key={subItem.text} disablePadding>
                      <ListItemButton
                        component={NavLink}
                        to={subItem.to}
                        sx={{
                          minHeight: 36,
                          pl: open ? 4 : 2,
                          "&:hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.04)",
                          },
                          "&.active": {
                            color: "white",
                          },
                        }}
                      >
                        <ListItemIcon sx={{
                          minWidth: 0,
                          mr: open ? 2 : "auto",
                          color: "inherit",
                        }}>
                          {subItem.icon}
                        </ListItemIcon>
                        {open && (
                          <ListItemText
                            primary={<Trans>{subItem.text}</Trans>}
                            primaryTypographyProps={{
                              fontSize: '0.875rem',
                            }}
                          />
                        )}
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            </>
          ) : (
            <ListItemButton
              component={NavLink}
              to={item.to}
              sx={{
                minHeight: 40,
                px: 2,
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.04)",
                },
                "&.active": {
                  color: "white",
                },
              }}
            >
              <ListItemIcon sx={{
                minWidth: 0,
                mr: open ? 2.5 : "auto",
                color: "inherit",
              }}>
                {item.icon}
              </ListItemIcon>
              {open && (
                <ListItemText
                  primary={<Trans>{item.text}</Trans>}
                  sx={{
                    opacity: open ? 1 : 0,
                    "& .MuiTypography-root": {
                      fontSize: "0.875rem",
                    },
                  }}
                />
              )}
            </ListItemButton>
          )}
        </ListItem>
      </React.Fragment>
    ))}
  </List>
)}
                  </>
                )}

                {!isTicketAdmin && (
                  <>
                    <ListItemButton onClick={handleTourPackageClick}>
                      <ListItemIcon>
                        <CarIcon />
                      </ListItemIcon>
                      <ListItemText primary="TourPackages" />
                      {tourPackageOpen ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Divider />
                    {tourPackageOpen && (
                      <List component="div" disablePadding>
                        {TourPackageItems.map((item) => (
                          <ListItem key={item.text} disablePadding sx={{ display: "block" }}>
                            <ListItemButton
                              component={NavLink}
                              to={item.to}
                              sx={{
                                minHeight: 30,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                                color: "inherit",
                                "&:hover": {
                                  backgroundColor: "rgba(255, 255, 255, 0.04)",
                                },
                                "&.active": {
                                  color: "white",
                                },
                              }}
                              activeClassName="active"
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: open ? 3 : "auto",
                                  justifyContent: "center",
                                  color: "inherit",
                                  fontSize: "small",
                                }}
                              >
                                {item.icon}
                              </ListItemIcon>
                              <ListItemText
                                primary={<Trans>{item.text}</Trans>}
                                sx={{
                                  opacity: open ? 1 : 0,
                                  "& .MuiTypography-root": {
                                    fontSize: "0.875rem",
                                  },
                                }}
                              />
                            </ListItemButton>
                          </ListItem>
                        ))}
                      </List>
                    )}
                  </>
                )}

                <ListItemButton onClick={handleTicketsClick}>
                  <ListItemIcon>
                    <img src={TicketIcon} alt="Tickets" style={{ width: '24px', height: '24px' }} />
                  </ListItemIcon>
                  <ListItemText primary="Tickets" />
                  {ticketsOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Divider />

                {ticketsOpen && (
                  <List component="div" disablePadding dense>
                    {ticketsItems.map((item) => (
                      <React.Fragment key={item.text}>
                        <ListItem disablePadding sx={{ display: "block" }}>
                          {item.children ? (
                            <>
                              <ListItemButton
                                onClick={() => handleToggle(item.text)}
                                sx={{
                                  minHeight: 40,
                                  px: 2,
                                  "&:hover": {
                                    backgroundColor: "rgba(255, 255, 255, 0.04)",
                                  },
                                }}
                              >
                                <ListItemIcon sx={{
                                  minWidth: 0,
                                  mr: open ? 2.5 : "auto",
                                  color: "inherit",
                                }}>
                                  {item.icon}
                                </ListItemIcon>
                                {open && (
                                  <>
                                    <ListItemText
                                      primary={item.text}
                                      primaryTypographyProps={{
                                        fontSize: '0.875rem',
                                      }}
                                    />
                                    {openMenus[item.text] ? <ExpandLess /> : <ExpandMore />}
                                  </>
                                )}
                              </ListItemButton>

                              {ticketsOpen && (
                                <Collapse in={openMenus[item.text]} unmountOnExit>
                                  <List component="div" disablePadding>
                                    {item.children.map((subItem) => (
                                      <ListItem key={subItem.text} disablePadding>
                                        <ListItemButton
                                          component={NavLink}
                                          to={subItem.to}
                                          sx={{
                                            minHeight: 36,
                                            pl: open ? 4 : 2,
                                            "&:hover": {
                                              backgroundColor: "rgba(255, 255, 255, 0.04)",
                                            },
                                            "&.active": {
                                              color: "white",
                                            },
                                          }}
                                        >
                                          <ListItemIcon sx={{
                                            minWidth: 0,
                                            mr: open ? 2 : "auto",
                                            color: "inherit",
                                          }}>
                                            {subItem.icon}
                                          </ListItemIcon>
                                          {open && (
                                            <ListItemText
                                              primary={subItem.text}
                                              primaryTypographyProps={{
                                                fontSize: '0.875rem',
                                              }}
                                            />
                                          )}
                                        </ListItemButton>
                                      </ListItem>
                                    ))}
                                  </List>
                                </Collapse>
                              )}
                            </>
                          ) : (
                            <ListItemButton
                              component={NavLink}
                              to={item.to}
                              sx={{
                                minHeight: 40,
                                px: 2,
                                "&:hover": {
                                  backgroundColor: "rgba(255, 255, 255, 0.04)",
                                },
                                "&.active": {
                                  color: "white",
                                },
                              }}
                            >
                              <ListItemIcon sx={{
                                minWidth: 0,
                                mr: open ? 2.5 : "auto",
                                color: "inherit",
                              }}>
                                {item.icon}
                              </ListItemIcon>
                              {open && (
                                <ListItemText
                                  primary={item.text}
                                  primaryTypographyProps={{
                                    fontSize: '0.875rem',
                                  }}
                                />
                              )}
                            </ListItemButton>
                          )}
                        </ListItem>
                      </React.Fragment>
                    ))}
                  </List>
                )}
              </>
            )}
          </List>
        </Box>
      </Drawer>
    </Box>
  );
}

export default Sidebar1;
